module.exports = __webpack_public_path__ + "img/logo_NU_muslimat.c11b171b.jpeg";